import Text from 'components/_UI/Text';
import DynamicProfileImage from 'components/commons/DynamicProfileImage';
import styled from 'styled-components';
import { FullyCentered } from 'styled/alignment/Center';
import { Column } from 'styled/alignment/Column';
import { Row } from 'styled/alignment/Row';
import { Heart, MapPin } from 'lucide-react';
import colors from 'theme/colors';
import { useNavigate } from 'react-router-dom';
// TODO: Descomentar quando o endpoint de favoritar estabelecimentos estiver pronto
// import useFavorite from 'hooks/useFavorite';

export default function EstablishmentCardV2({
    data,
    onCardClick,
}) {
    // TODO: Descomentar quando o endpoint de favoritar estabelecimentos estiver pronto
    // const { isFavorited, toggleFavorite } = useFavorite(data?.slug, data?.is_favorited || false, null, 'establishment');
    const navigate = useNavigate();

    function handleCardClick() {
        if (onCardClick) {
            onCardClick(data);
        } else {
            navigate(`/estabelecimento/${data?.slug}/detalhes`);
        }
    }

    return (
        <CardContainer onClick={handleCardClick}>
            <ImageWrapper>
                <BackgroundImage
                    src={data?.backgroundImage?.path || '/assets/images/placeholder-events.png'}
                    onError={(e) => { e.target.onerror = null; e.target.src = '/assets/images/placeholder-events.png'; }}
                />

                <TopBadgesContainer>
                    <Badge isOpen={data?.dates?.open || data?.open}>
                        <Text name='mini' color={colors.neutralLight} paddingBottom={0}>
                            {(data?.dates?.open || data?.open) ? 'Aberto' : 'Fechado'}
                        </Text>
                    </Badge>
                </TopBadgesContainer>

                {/* TODO: Descomentar quando o endpoint de favoritar estabelecimentos estiver pronto
                <FavoriteContent onClick={(e) => {
                    e.stopPropagation();
                    toggleFavorite();
                }}>
                    <Heart
                        size={14}
                        color={isFavorited ? colors.occasionalPink : colors.nightLight}
                        fill={isFavorited ? colors.occasionalPink : 'none'}
                    />
                </FavoriteContent> */}
            </ImageWrapper>

            <ProfileSection>
                <ProfileImageBorder>
                    <DynamicProfileImage
                        img={data?.profileImage?.path}
                        word={data?.name}
                        size='50px'
                        textSize='highlight'
                    />
                </ProfileImageBorder>
            </ProfileSection>

            <CardContent>
                <Text
                    type='bold'
                    color={colors.nightDark}
                    ellipsisAt='95%'
                    paddingBottom={0}
                >
                    {data?.name}
                </Text>

                <Row verticalCenter>
                    <MapPin size={13} color={colors.nightLight} />
                    <Text name='small' ellipsisAt='95%' marginLeft='4px' paddingBottom={0}>
                        {data?.address?.name
                            ? `${data.address.name}, `
                            : data?.address?.street
                                ? `${data.address.street}, `
                                : ''}
                        {data?.address?.district && `Bairro ${data.address.district}`}
                    </Text>
                </Row>

                {data?.tagsEstablishments?.length > 0 && (
                    <Row>
                        <Text name='mini' ellipsisAt='95%' paddingBottom='0px' marginLeft='3px'>
                            {data.tagsEstablishments.map(item => `#${item.name} `)}
                        </Text>
                    </Row>
                )}
            </CardContent>
        </CardContainer>
    );
}

const CardContainer = styled(Column)`
    width: 100%;
    cursor: pointer;
    position: relative;
    background: transparent;
   
    &:hover img:first-child {
        transform: translateY(-2px);
        box-shadow: 0 2px 16px rgba(0, 0, 0, 0.12);
    }
`;

const ImageWrapper = styled.div`
    position: relative;
    width: 100%;
    aspect-ratio: 3 / 2;
    height: 120px;
    border-radius: 12px;
    overflow: hidden;
`;

const BackgroundImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    border-radius: 12px;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
`;

const TopBadgesContainer = styled(Row)`
    position: absolute;
    top: 10px;
    left: 8px;
    width: auto;
    z-index: 2;
`;

const Badge = styled(FullyCentered)`
    padding: 4px 8px;
    border-radius: 6px;
    margin-right: 4px;
    width: auto;
    background: ${({ isOpen }) => isOpen ? 'rgba(43, 200, 102, 0.85)' : 'rgba(231, 80, 90, 0.85)'};
`;

const FavoriteContent = styled(FullyCentered)`
    position: absolute;
    top: 10px;
    right: 10px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.9);
    cursor: pointer;
    z-index: 2;
`;

const ProfileSection = styled(FullyCentered)`
    margin-top: -26px;
    z-index: 2;
    position: relative;
`;

const ProfileImageBorder = styled(FullyCentered)`
    width: 54px;
    height: 54px;
    border: 3px solid ${colors.neutralLight};
    border-radius: 50%;
    background: ${colors.neutralLight};
    overflow: hidden;
`;

const CardContent = styled(Column)`
    padding: 8px 4px 4px;
    gap: 4px;
    align-items: center;
    text-align: center;
`;
